import { COURSE_TYPES } from 'data/courseTypes';
import { IGroupContestOffsetDuration } from 'types/IGroupContestOffsetDuration';

export const GROUP_CONTEST_OFFSET_DURATION: IGroupContestOffsetDuration = {
  [COURSE_TYPES.academy]: [0, 0, 7, 0],
  [COURSE_TYPES.dsml]: [0, 0, 14, 14],
  [COURSE_TYPES.neovarsity]: [0, 0, 60, 60],
  [COURSE_TYPES.academyWithoutDsa]: [0, 0, 0, 0],
} as const;
